import { Tooltip, TooltipContent, TooltipTrigger } from "@aircall/ds";

import { ExtraItems } from "../ExtraItems/ExtraItems";

import type {
  CellTypographyProps,
  DisplayExtraProps,
} from "./CellTypography.decl";

const EMPTY_EXTRA_ENTRIES: { id: string | number; text: string }[] = [];

function DisplayExtra({ extraEntries }: DisplayExtraProps) {
  if (!extraEntries?.length) {
    return null;
  }

  return <ExtraItems items={extraEntries} />;
}

export function CellTypography({
  children,
  extraEntries = EMPTY_EXTRA_ENTRIES,
  tooltipTitle,
  "data-test": dataTest = "cell-typography",
}: CellTypographyProps) {
  const mainText = (
    <span
      data-test={`${dataTest}-main`}
      className="capitalize truncate min-w-0"
    >
      {children}
    </span>
  );

  return (
    <div
      data-test={dataTest}
      className="flex gap-2 items-center w-[175px] min-[1440px]:w-[210px]"
    >
      {tooltipTitle ? (
        <Tooltip>
          <TooltipTrigger render={mainText} />
          <TooltipContent>{tooltipTitle}</TooltipContent>
        </Tooltip>
      ) : (
        mainText
      )}
      <DisplayExtra extraEntries={extraEntries} />
    </div>
  );
}
